import styled, { keyframes } from 'styled-components';
import { BaseBubble } from '@vh/components/VHOverlay/ActiveChat/ChatItem/FloatingChatBubble/FloatingChatBubble.styled';
import { Icon } from '@virtidev/toolbox';

const fadeIn = keyframes`
  from {opacity: 0;}
  to {opacity: 1;}
`;

export const InputOptionsWrapper = styled.div`
  margin: auto;
`;
export const InputOptionsSubwrapper = styled.div`
  display: grid;
  padding: 0 0.5rem;
  width: 100%;
  gap: 0.3rem;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 20svh;
  max-width: 60rem;
  align-self: center;
  &::-webkit-scrollbar {
    width: 0.6rem;
  }
  &::-webkit-scrollbar-track {
    background-color: ${(props) => props.theme.color.primaryLight};
    border-radius: ${(props) => props.theme.borderRadius.lg};
  }
  &::-webkit-scrollbar-thumb {
    border-radius: ${(props) => props.theme.borderRadius.lg};
    background-color: ${(props) => props.theme.color.primaryDark};
    cursor: pointer;
  }
`;

export const SubmitAndCompleteSessionButtons = styled.div`
  animation: ${fadeIn} 0.5s;
  display: grid;
  grid-template-columns: 1fr;
`;

export const ButtonsWrapper = styled.div`
  animation: ${fadeIn} 0.5s;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding-top: 0.5rem;
  align-items: center;
`;

export const SendIcon = styled(Icon)`
  color: ${(props) => props.theme.color.darkGrey};
  margin: 2px -3px 0 0;
`;

export const InputOption = styled(BaseBubble)`
  animation: ${fadeIn} 0.5s;
  cursor: pointer;
  display: flex;
  gap: 8px;
  background: #ffffffdd;
  color: ${(props) => props.theme.color.base};
  border: 1px solid ${(props) => props.theme.color.darkGrey};

  &:hover,
  &:active,
  &:focus {
    border-color: ${(props) => props.theme.color.primary};
    background: #ffffff;

    ${SendIcon} {
      color: ${(props) => props.theme.color.primary};
    }
  }
  &:disabled {
    background-color: #e4e4e4;
    pointer-events: none;
  }
`;
